<template>
<div class="edit-area" v-loading.fullscreen.lock="fullscreenLoading" >
  <div class="container-base fullscreen">
    <h1>
      ヤギの宅配便
    </h1>
    <p style="color: red;font-size: 0.8rem;" v-if="false">年末年始（12/27-1/4）は発送までお時間いただくことがあります。ご了承ください。</p>
    <a v-if="isMaint" href="https://www.yagish.jp/information/yagitaku20231101/" target="_blank" style="font-size:0.8rem;font-weight:bold;color:#E3165C;">【11/1-11/7】ヤギの宅配便のサービスメンテナンスのお知らせ</a>
    <div class="overflow-scroll-x step"
      ref="step">
      <ol>
        <li v-for="(item, index) in quickmailCards"
          :ref="'steps'"
          :key="item.id"
          :index="index"
          :class="{current:(item.id == currentCardId),
                     over:(index < currentCardIndex)}"
          v-ripple>
          <a href="#"
             @click="goCardTo(item.id);$event.preventDefault()">
            {{ item.title }}
          </a>
        </li>
      </ol>
    </div>
    <v-touch v-bind:enabled="{swipe:true, press:false, pan:false, tap:false, rotate:false, pinch:false}"
      v-on:swipeleft="swipeNextCard"
      v-on:swiperight="swipePrevCard"
      v-bind:swipe-options="{direction:'horizontal'}">
      <div class="cards"
        v-show="currentCardId">
        <div class="card-pager-nav">
          <div class="pager">
            <el-button v-ripple
              v-if="currentCardId=='info'"
              @click="goNextCard"
              :disabled="!isNextCardAvailable"
              type="primary">
              ヤギの宅配便をつかう <i class="el-icon-d-arrow-right"></i>
            </el-button>
            <el-button v-ripple
              v-else-if="currentCardId!='payment'"
              @click="goNextCard"
              :disabled="!isNextCardAvailable"
              type="primary">
              次へ <i class="el-icon-d-arrow-right"></i>
            </el-button>

            <el-button v-ripple

              v-if="false"
              icon="el-icon-d-arrow-left"
              @click="goPrevCard"
              :type="isNextCardAvailable ? 'text': 'primary'"
              :disabled="!isPrevCardAvailable">
              前へ
            </el-button>
          </div>
        </div>

        <component v-bind:is="buyform"
          ref="editFormat"
          :current-card-id="currentCardId"></component>

        <div class="card-pager-nav">
          <div class="pager">
            <el-button v-ripple
              v-if="currentCardId=='info'"
              @click="goNextCard"
              :disabled="!isNextCardAvailable"
              type="primary">
              ヤギの宅配便をつかう <i class="el-icon-d-arrow-right"></i>
            </el-button>
            <el-button v-ripple
              v-else-if="currentCardId!='payment'"
              @click="goNextCard"
              :disabled="!isNextCardAvailable"
              type="primary">
              次へ <i class="el-icon-d-arrow-right"></i>
            </el-button>
            <el-button v-ripple
              v-else
              @click="paymentQuickmail"
              :disabled="!isNextCardAvailable || paymentMethod == 'amazon'"
              type="primary">
              上記の内容で購入を行う <i class="el-icon-d-arrow-right"></i>
            </el-button>

            <el-button v-ripple
              v-if="currentCardId!='complete'"
              icon="el-icon-d-arrow-left"
              @click="goPrevCard"
              :type="isNextCardAvailable ? 'text': 'primary'"
              :disabled="!isPrevCardAvailable">
              前へ
            </el-button>
          </div>
        </div>
      </div>
    </v-touch>
  </div>
</div>
</template>
<style lang="scss" src="@/assets/scss/formats.scss"></style>
<script>
import basicInfo from '@/components/BasicInfo'
import timeAgo from '@/assets/lib/time-ago-jp'
import _ from '@/assets/lib/my-lodash'
import QuickmailCards from '@/assets/formats/quickmail-cards'
import QuickmailBuy from '@/components/formats/QuickmailBuy'
import LoginForms from '@/components/RenewLoginForms'
import firebase from 'firebase/app'
const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const LAST_SAVE_DATE_SAVE_KEY = 'lastSaveDate'

export default {
  props: {
    formatId: {
      type: String
    },
    preview: {
      type: Boolean,
      default: false
    },
    cardId: {
      type: String
    }
  },
  components: {
    'login-forms': LoginForms
  },
  data: function () {
    return {
      fullscreenLoading: false,
      buyform: QuickmailBuy,
      quickmailCards: QuickmailCards,
      formatData: {},
      formatInfo: {},
      basicData: {},
      basicInfo: basicInfo,
      requiredBasicFields: [],
      currentCardId: '',
      paymentMethod: 'card',
      previewHtml: '',
      previewDialogVisible: true,
      previewScale: 1,
      previewViewerCss: {},
      previewTabActive: 'previewFormat',
      mailPDFSending: false,
      saveNotifyMessage: '',
      saveNotifyMessageUpdateTimer: null,
      saveDate: null,
      devAreaVisible: false,
      currentFormat: {},
      isMaint:false,
      downloadPdfEnabled: true,
      isDisplayedRirekishoPreview: false,
      rirekishoHTMLData: '',
      fontOptions: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'yagishゴシック'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'yagish明朝'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: 'ドットゴシック16'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
      fontNames: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'yagishゴシック'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'yagish明朝'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: 'ドットゴシック16'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
      pdfBlob: null
    }
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    previewDialogStyleObject: function () {
      if (this.previewDialogVisible) {
        return {
          visibility: 'visible',
          height: 'auto'
        }
      } else {
        return {
          visibility: 'hidden',
          overflow: 'hidden',
          height: 0
        }
      }
    },
    isDevelopment: function () {
      return process.env.NODE_ENV === 'development'
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    },
    firstCardId: function () {
      console.error(this.quickmailCards[0].id)
      return this.quickmailCards[0].id
    },
    isNextCardAvailable: function () {
      if (!this.currentCardId) return
      return this.currentCardIndex + 1 < this.quickmailCards.length
    },
    isPrevCardAvailable: function () {
      if (!this.currentCardId) return
      return this.currentCardIndex > 0
    },
    currentCardIndex: function () {
      if (!this.currentCardId) return -1
      let key, card
      for (key in this.quickmailCards) {
        card = this.quickmailCards[key]
        if (this.currentCardId === card.id) {
          return Number(key)
        }
      }
      return -1
    },
    currentCardTitle: function () {
      if (!this.currentCardId) return ''
      return this.quickmailCards[this.currentCardIndex].title
    },
    currentCardPreviewJumpId: function () {
      if (!this.currentCardId) return ''
      return this.quickmailCards[this.currentCardIndex].previewJumpId
    },
    nextCardLabel: function () {
      if (this.isNextCardAvailable) {
        return this.quickmailCards[this.currentCardIndex + 1].title
      }
      return ''
    },
    prevCardLabel: function () {
      if (this.isPrevCardAvailable) {
        return this.quickmailCards[this.currentCardIndex - 1].title
      }
      return ''
    }
  },
  methods: {
    cardIdExists: function (cardId) {
      for (const key in this.quickmailCards) {
        if (this.quickmailCards[key].id === cardId) {
          return true
        }
      }
      return false
    },
    changePaymentMethod: function (pmethod) {
      this.paymentMethod = pmethod
    },
    goFirstCard: function () {
      this.goCardTo(this.firstCardId)
    },
    goCurrentCard: function () {
      this.previewDialogVisible = false
      if (this.currentCardId == 'rirekisho') {
        this.$refs.editFormat.setLetterInnerHtml()
        this.isDisplayedRirekishoPreview = true
      } else if (this.currentCardId == 'letter') {
        this.$refs.editFormat.setCheckLetter()
      } else if (this.currentCardId == 'keirekisho') {
        this.$refs.editFormat.setRirekishoInnerHtml()
      } else if (this.currentCardId == 'payment') {
        this.$refs.editFormat.setRirekishoInnerHtml()
        this.$refs.editFormat.setKeirekishoInnerHtml()
        this.$refs.editFormat.setAddressDataStaffName()
      console.error(this.rirekishoHTMLData)
        if (!this.isDisplayedRirekishoPreview) {
          this.$message({
            message: '履歴書のプレビューをご確認ください',
            type: 'error'
          })
          this.goCardTo('rirekisho')
        }

      }
      this.$router.push({
        name: 'quickmailCard',
        params: {
          cardId: this.currentCardId
        }
      })
      this.$refs.editFormat.setPreviewScale()

      this.$refs.editFormat.$refs.previewLetterFormat.checkValid()
      this.$refs.editFormat.$refs.previewRirekishoFormat.checkValid()
      console.error("this.$refs.editFormat.$refs.previewLetterFormat.checkValid()")

      this.$eventHub.$emit('deactivate-history-item')
      this.$eventHub.$emit('card-changed', this.currentCardId)
    },
    getPreviewRirekishoFormat: function () {
      // console.error(this.$refs.editFormat.$refs.previewRirekishoFormat.$el.innerHTML)
      return this.$refs.editFormat.$refs.previewRirekishoFormat.$el.innerHTML
    },
    scrollToCurrentStep: function () {
      this.$nextTick(function () {
        if (this.currentCardIndex < 0) {
          return
        }
        this.$refs.steps[this.currentCardIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'center'
        })
      })
    },
    goCardTo: function (cardId) {
      if (!this.cardIdExists(cardId)) {
        this.goFirstCard()
        return
      }
      if (cardId == 'complete') {
        return
      }
      this.currentCardId = cardId
      this.goCurrentCard()
      this.scrollToCurrentStep()
    },
    goNextCard: function () {
      if (!this.$firebase.isAuthenticated) {
        this.$eventHub.$emit('open-loginform-dialog', this.formatId, 'save')
      }
      if (this.isNextCardAvailable) {
        this.currentCardId = this.quickmailCards[this.currentCardIndex + 1].id
        this.goCurrentCard()
        this.scrollToCurrentStep()
      }
    },
    goPrevCard: function () {
      if (this.isPrevCardAvailable) {
        this.currentCardId = this.quickmailCards[this.currentCardIndex - 1].id
        this.goCurrentCard()
        this.scrollToCurrentStep()
      }
    },
    gotoBasic: function () {
      this.goCardTo('basic')
    },
    goDownloadCard: function () {
      this.goCardTo('output')
    },
    swipeNextCard: function () {
      if (this.$deviceLib.isMobileDevice) {
        this.goNextCard()
      }
    },
    swipePrevCard: function () {
      if (this.$deviceLib.isMobileDevice) {
        this.goPrevCard()
      }
    },
    setPreviewScaleDebounce: function (e) {
      _.debounce(this.setPreviewScale, 1000)
    },
    paymentQuickmailResult: function (param) {
      this.fullscreenLoading = false
      if (param == 'success') {
        this.currentCardId = 'complete'
        this.goCurrentCard()
        this.scrollToCurrentStep()
      }
    },
    loadingOn: function() {
      this.fullscreenLoading = true
    },
    getPayPayCode: function() {
      const app = this
      if (!this.inputCheck()) {
        return
      } 
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('version', '3')
      this.$axios
        .post(this.$varuna.endPoints.getPaypaycodeQmail, formData, {timeout: 60000})
        .then(async function (response) {
          console.error(response['data']['status'])
          if (response['data']['status'] == 'success') {
            console.error(response['data'])
            app.$refs.editFormat.savePayPayTempData(response['data']['merchant_payment_id'], response['data']['data']['url'])
          } else {
            app.$message({
              message: '取得失敗しました',
              type: 'error'
            })
          }
        })
        .catch(function (error) {
          console.error(error)
          app.$message({
            message: '取得中に問題が発生しました',
            type: 'error'
          })
        }).finally(function () {
        })
    },
    inputCheck: function () {
      const app = this

      if (app.isMaint) {
        app.$message({
          message: '以下の日時においてヤギの宅配便サービスの休止を予定しています。【利用一時休止期間】11/1 12:00 〜  11/7 18:00',
          type: 'error'
        })
        return false
      }
      if (!this.$refs.editFormat.formatData.addressData_postNumber) {
        app.$message({
          message: '送付先の郵便番号を入力してください',
          type: 'error'
        })
        return false
      } 
      if (!this.$refs.editFormat.formatData.addressData_address1) {
        app.$message({
          message: '送付先の都道府県・市区町村・番地を入力してください',
          type: 'error'
        })
        return false
      } 
      if (!this.$refs.editFormat.formatData.addressData_companyName) {
        app.$message({
          message: '送付先の会社名を入力してください',
          type: 'error'
        })
        return false
      } 
      // if (!this.$refs.editFormat.formatData.addressData_staffName) {
      //   app.$message({
      //     message: '送付先の担当者名を入力してください',
      //     type: 'error'
      //   })
      //   return
      // } 
      if (!this.$refs.editFormat.formatData.from_name) {
        app.$message({
          message: '差出人名を入力してください',
          type: 'error'
        })
        return false
      } 
      if (!this.$refs.editFormat.formatData.from_post) {
        app.$message({
          message: '差出人の郵便番号を入力してください',
          type: 'error'
        })
        return false
      } 
      if (!this.$refs.editFormat.formatData.from_address1) {
        app.$message({
          message: '差出人の住所を入力してください',
          type: 'error'
        })
        return false
      } 
      if (this.paymentMethod == 'card') {
        this.$refs.editFormat.$refs.stripeCardElememt.submit()
      } else if (this.paymentMethod == 'paypay') {
        
      } else {
        if (!this.$refs.editFormat.formatData.ecCode) {
          app.$message({
            message: 'コードを入力してください',
            type: 'error'
          })
          return false
        }

      }
      return true
    },
    paymentQuickmail: function () {
      console.error(this.paymentMethod)
      const app = this
      if (app.isMaint) {
        app.$message({
          message: '以下の日時においてヤギの宅配便サービスの休止を予定しています。【利用一時休止期間】11/1 12:00 〜  11/7 18:00',
          type: 'error'
        })
        return
      }
      if (!this.$refs.editFormat.formatData.addressData_postNumber) {
        app.$message({
          message: '送付先の郵便番号を入力してください',
          type: 'error'
        })
        return
      } 
      if (!this.$refs.editFormat.formatData.addressData_address1) {
        app.$message({
          message: '送付先の都道府県・市区町村・番地を入力してください',
          type: 'error'
        })
        return
      } 
      if (!this.$refs.editFormat.formatData.addressData_companyName) {
        app.$message({
          message: '送付先の会社名を入力してください',
          type: 'error'
        })
        return
      } 
      // if (!this.$refs.editFormat.formatData.addressData_staffName) {
      //   app.$message({
      //     message: '送付先の担当者名を入力してください',
      //     type: 'error'
      //   })
      //   return
      // } 
      if (!this.$refs.editFormat.formatData.from_name) {
        app.$message({
          message: '差出人名を入力してください',
          type: 'error'
        })
        return
      } 
      if (!this.$refs.editFormat.formatData.from_post) {
        app.$message({
          message: '差出人の郵便番号を入力してください',
          type: 'error'
        })
        return
      } 
      if (!this.$refs.editFormat.formatData.from_address1) {
        app.$message({
          message: '差出人の住所を入力してください',
          type: 'error'
        })
        return
      } 
      if (this.paymentMethod == 'card') {
        this.$refs.editFormat.$refs.stripeCardElememt.submit()
      } else if (this.paymentMethod == 'code') {
        if (!this.$refs.editFormat.formatData.ecCode) {
          app.$message({
            message: 'コードを入力してください',
            type: 'error'
          })
          return
        } else {

          app.$eventHub.$emit('token_created', null)
        }

      }
      
      
    },
    complatePayPay: function (merchant_payment_id) {

      const app = this
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('merchant_payment_id', merchant_payment_id)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('site_flag', 'r')
      formData.append('version', '3')
      this.$axios
        .post(this.$varuna.endPoints.paypayComplateQuickmail, formData, {timeout: 60000})
        .then(async function (response) {
          if (response['data']['status'] == 'success') {
          // if (response['data']['data']['status'] == 'COMPLETED') {
            app.$message({
              duration: 0,
              message: '支払確認ができました。購入処理を完了します',
              type: 'success'
            })
            app.fullscreenLoading = false
            app.paymentQuickmailResult('success')
          } else {
            app.$message({
              duration: 0,
              message: '取得失敗しました。エラーコード：EQ1001',
              type: 'error'
            })
          }
        })
        .catch(function (error) {
          console.error(error)
          app.$message({
            message: '取得失敗しました。',
            type: 'error'
          })
        }).finally(function () {
          // app.goCardTo('payment')
          app.fullscreenLoading = false
        })
    },
    paymentQuickEmail: function () {
      const app = this
      if (!this.inputCheck()) {
        return
      } 
      this.fullscreenLoading = true
      if (this.$refs.editFormat.formatId=='rirekisho_job_new' || this.$refs.editFormat.formatId=='rirekisho_job_new_single') {
        console.error(this.$refs.editFormat.formatId)
        this.$refs.editFormat.tokenCreated()
        
      } else {
        this.$refs.editFormat.$refs.stripeCardElememt.submit()

      }

    }
  },
  watch: {
    'cardId': function () {
      this.currentCardId = this.cardId
      if (this.currentCardIndex < 0) {
        this.goFirstCard()
      }
    },
    previewTabActive: function () {
      this.setPreviewScale()
    }
  },
  beforeMount: function () {
    const app = this
    if (this.$route.query.merchant_payment_id) {
      // this.fullscreenLoading = true
    } else {
      if (this.cardId) {
        if (this.cardId != 'basic') {
          this.$router.push({
            name: 'quickmailCard',
            params: {
              cardId: 'basic'
            }
          })
        }
      }
    }
  },
  beforeDestroy() {
  },
  created: function () {
    const app = this
    // console.log(this.$route.query.mynavi)
    // firebase.auth().onAuthStateChanged((user) => {
    //   if (user) {    
    //     console.log('logined')
    //   } else {
    //     this.$router.push('/login')
    //   }
    // })

    const nowdate = new Date()
    const date1 = new Date('2023/11/01 12:00:00')
    const date2 = new Date('2023/11/07 18:00:00')
    if (nowdate > date1 && nowdate < date2) {
      this.isMaint = true
    } else {
      this.isMaint = false
    }
  },
  mounted: function () {
    if (this.$route.query.merchant_payment_id) {
      this.fullscreenLoading = true
      this.complatePayPay(this.$route.query.merchant_payment_id)
    } else {
      if (this.currentCardIndex < 0) {
        this.goFirstCard()
      }
    }
    // set event listeners and timer
    window.addEventListener('popstate', this.hidePreviewDialog, false)
    window.addEventListener('resize', this.setPreviewScaleDebounce, false)
    this.scrollToCurrentStep()
    this.$eventHub.$on('payment_result', this.paymentQuickmailResult)
    this.$eventHub.$on('goto_basic', this.gotoBasic)
    this.$eventHub.$on('loading_on', this.loadingOn)
    this.$eventHub.$on('change_payment_method', this.changePaymentMethod)
    this.$eventHub.$on('go_next_card', this.goNextCard)
    this.$eventHub.$on('email_loading_on', this.loadingOn)
    this.$eventHub.$on('get_paypay_code', this.getPayPayCode)
    this.$eventHub.$on('complate_paypay', this.complatePayPay)
    this.$eventHub.$on('get_rirekisho_html', this.getPreviewRirekishoFormat)
  },
  destroyed: function () {
    // remove event listeners and timer
    clearInterval(this.saveNotifyMessageUpdateTimer)
    this.$eventHub.$off('payment_result', this.paymentQuickmailResult)
    this.$eventHub.$off('goto_basic', this.gotoBasic)
    this.$eventHub.$off('loading_on', this.loadingOn)
    this.$eventHub.$off('change_payment_method', this.changePaymentMethod)
    this.$eventHub.$off('go_next_card', this.goNextCard)
    this.$eventHub.$off('email_loading_on', this.loadingOn)
    this.$eventHub.$off('get_paypay_code', this.getPayPayCode)
    this.$eventHub.$off('complate_paypay', this.complatePayPay)
    this.$eventHub.$off('get_rirekisho_html', this.getPreviewRirekishoFormat)
  }
}
</script>
